import { render, staticRenderFns } from "./ShopModels.vue?vue&type=template&id=2edaa196&"
import script from "./ShopModels.vue?vue&type=script&lang=js&"
export * from "./ShopModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports